<div class="container">
  <div>
    <h2>Frage {{questionIndex + 1}}</h2>
    <p>{{exam.examQuestions[questionIndex].question}}</p>
  </div>
  <app-quill-textarea formControlName="userAnswer" [control]="getControl('userAnswer')" [placeholder]="'Bitte gib deine Antwort ein...'"></app-quill-textarea>
  <app-button [text]="questionIndex < exam.examQuestions.length - 1 ? 'Nächste Frage' : 'Klausur abschließen'" [loading]="isSavingExamQuestions" (clickEvent)="next()"></app-button>
</div>